import { AppDispatchNext, AppGetState } from 'actions/actions.typesNext'
import { settingsFilterPhotoVerificationAnnouncementAction } from 'actions/miscellaneous/settingsFilterPhotoVerificationAnnouncementAction'
import { fetchUniNoticeAction } from 'actions/uninotice/uniNoticeAction'
import { UniNoticeId } from 'components/uninotice/uninotice.types'

export const showSettingsFilterPhotoAction =
  () => (dispatch: AppDispatchNext, getState: AppGetState) => {
    const {
      miscellaneous: { settingsFilterPhotoVerificationAnnouncement },
      authorizationReducer: {
        profile: { id },
      },
    } = getState()

    if (id && !settingsFilterPhotoVerificationAnnouncement?.[id]) {
      dispatch(
        fetchUniNoticeAction(
          UniNoticeId.messagesOnlyFromVerifiedByPhotoAnnouncement
        )
      )
      dispatch(settingsFilterPhotoVerificationAnnouncementAction(id))
    }
  }
